import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG } from "@/types";
import LoginFormView from "@/pages/login/components/view/login-form-view";
import { routes } from "@/consts";
import { Languages } from "lucide-react";
import { Toaster } from "@/app/global-components/toaster";

const LoginPage: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const location = useLocation();
  const getNextLocale = () => {
    return locale === LANG.EN ? LANG.AR : LANG.EN;
  };
  const handleLanguageSwap = () => {
    const pathName = location.pathname;
    if (!pathName) return routes.home;
    const segments = pathName.split("/");
    segments[1] = getNextLocale();
    return segments.join("/");
  };
  const navigate = useNavigate();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 sm:p-6">
      <h1 className="text-2xl font-semibold sm:text-3xl">
        {t("authentication.login")}
      </h1>
      <section className="w-full mt-5 max-w-md bg-primary-white p-5 shadow-xl rounded-md sm:max-w-lg">
        <LoginFormView />
        <Toaster />

        <div className="flex flex-row justify-between items-start mt-4">
          <div
            onClick={() => navigate(handleLanguageSwap())}
            className="cursor-pointer text-lg flex items-center  gap-2"
          >
            <Languages />
            <div>{locale == LANG.AR ? "عربي" : "english"}</div>
          </div>
          <p className="mb-4 text-textcolor-mediumGray text-sm sm:text-base">
            {t("authentication.newAccount")}{" "}
            <Link
              to={routes.register}
              className="font-bold text-purple-700 underline-offset-4"
            >
              {t("authentication.register")}
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default LoginPage;
